import React, {useEffect} from "react";
import {Form, Modal} from "react-bootstrap";
import cogoToast from "cogo-toast";
import { useDisablePlanMutation } from "../../../../../redux/apiSlice";

const DisablePlanModal = ({showDisablePlanModal, onHide, planDetails, tableRef}) => {
   
    const [
        disablePlan, // This is the mutation trigger
        {
            isLoading: isUpdating
        }, // This is the destructured mutation result
    ] = useDisablePlanMutation()


    const onSubmit = e => {
        e.preventDefault();
        e.stopPropagation();

        disablePlan({
            planId: planDetails?.planId
        })
        .unwrap()
    .then(() => {
        cogoToast.success("Created 'Disable Plan' Action Successfully")
        onHide()
    })
    }

   
    return (
        <Modal
            show={showDisablePlanModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            // backdrop={isUnfreezing ? "static" : true}
            // keyboard={!isUnfreezing}
        >
            <Form
                noValidate
                onSubmit={onSubmit}
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Disable Plan
                    </Modal.Title>
                    <button type="button" className="close" onClick={onHide}>
                        <span aria-hidden="true" className="d-block">×</span>
                        <span className="sr-only">Close</span>
                    </button>
                </Modal.Header>

                <Modal.Body style={{maxHeight: "calc(100vh - 300px)", overflow: "auto"}}>
                    <p>{`Are you sure you want to Disable ${planDetails?.planName} plan?`}</p>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        onClick={onHide}
                        // disabled={isUnfreezing}
                        className="btn btn-light btn-elevate px-4"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        // disabled={isUnfreezing}
                        className="btn btn-primary btn-elevate px-4 ml-4"
                    >
                        Disable
                    </button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default DisablePlanModal;
